(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

  // src/lib/upsell-debug.ts
  var isUpsellDebug = () => {
    var _a;
    if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) return true;
    try {
      return new URLSearchParams(window.location.search).get("rebuy_debug") === "1";
    } catch (e) {
      return false;
    }
  };

  // src/recommendation-engine.ts
  (() => {
    window.HotelCollection = window.HotelCollection || {};
    if (window.HotelCollection.RecommendationEngine) return;
    const CACHE_TTL_MS = 3e4;
    const log = (...args) => {
      if (isUpsellDebug()) console.log("[recs:engine]", ...args);
    };
    const tagMeta = (result, slot, fellBack) => {
      var _a, _b;
      return __spreadProps(__spreadValues({}, result), {
        meta: __spreadProps(__spreadValues({}, result.meta), {
          providerUsed: (_b = (_a = result.meta) == null ? void 0 : _a.providerUsed) != null ? _b : slot,
          fellBack
        })
      });
    };
    window.HotelCollection.RecommendationEngine = /* @__PURE__ */ (() => {
      let _provider = null;
      let _fallbackProvider = null;
      const _cache = /* @__PURE__ */ new Map();
      return {
        setProvider(provider) {
          _provider = provider;
          _cache.clear();
          log("provider set", provider);
        },
        getProvider() {
          return _provider;
        },
        setFallbackProvider(provider) {
          _fallbackProvider = provider;
          _cache.clear();
          log("fallback provider set", provider);
        },
        getFallbackProvider() {
          return _fallbackProvider;
        },
        clearCache() {
          _cache.clear();
          log("cache cleared");
        },
        async fetchHtml({ productId, variantId = "", limit = 8, intent = "related", sourceId = "" }) {
          if (!_provider && !_fallbackProvider) {
            log("fetchHtml: no provider");
            return { html: "", meta: { providerUsed: "none", fellBack: false } };
          }
          const key = `${productId}:${variantId}:${intent}:${limit}:${sourceId}`;
          const cached = _cache.get(key);
          if (cached && cached.expiresAt > Date.now()) {
            log("cache hit", key);
            return cached.result;
          }
          let primaryFailed = !_provider;
          if (_provider) {
            try {
              const result = await _provider.fetchHtml({ productId, variantId, limit, intent, sourceId });
              if (result.html) {
                const tagged = tagMeta(result, "rebuy", false);
                _cache.set(key, { result: tagged, expiresAt: Date.now() + CACHE_TTL_MS });
                log("primary fetched", key, "html length", result.html.length);
                return tagged;
              }
              log("primary returned empty \u2014 trying fallback");
              primaryFailed = true;
            } catch (err) {
              log("primary error \u2014 trying fallback", err);
              primaryFailed = true;
            }
          }
          if (primaryFailed && _fallbackProvider) {
            try {
              const result = await _fallbackProvider.fetchHtml({ productId, variantId, limit, intent, sourceId });
              const tagged = tagMeta(result, "shopify", true);
              _cache.set(key, { result: tagged, expiresAt: Date.now() + CACHE_TTL_MS });
              log("fallback fetched", key, "html length", result.html.length);
              return tagged;
            } catch (err) {
              log("fallback error", err);
            }
          }
          return {
            html: "",
            meta: { providerUsed: "none", fellBack: Boolean(_fallbackProvider) }
          };
        }
      };
    })();
  })();
})();
